export const UPDATE_EDOK_DOCUMENTATIONS_FAILURE = 'UPDATE_EDOK_DOCUMENTATIONS_FAILURE';

export const updateEdokDocumentationsFailure = error => ({
    type: UPDATE_EDOK_DOCUMENTATIONS_FAILURE,
    payload: error,
    error: true,
});
